import { IBreadcrumbItem } from '@/interfaces/general/IBreadcrumbItem.ts';

export function createDocumentBreadcrumbItems (
    documentTitle: string,
    documentShortCode: string,
    onResearchClick: () => void,
): Array<IBreadcrumbItem> {
    return [
        {
            label: 'Research',
            onClick: onResearchClick,
            id: 'research',
        },
        {
            label: documentTitle,
            id: documentShortCode,
        },
    ];
}
